// @ts-nocheck
import { ConfigContext, useConfigContext } from './ConfigContext';
import {
  ComplianceRequestContext,
  useComplianceRequestContext,
} from './ComplianceRequestContext';
import {
  ConsentStateContext,
  useConsentStateContext,
} from './ConsentStateContext';
import {
  ConsentTypesContext,
  useConsentTypesContext,
} from './ConsentTypesContext';
import {
  PrivacySettingsContext,
  usePrivacySettingsContext,
} from './PrivacySettingsContext';
import {
  WidgetStateContext,
  useWidgetStateContext,
} from './WidgetStateContext';

export function ContextProvider({ children }: { children: React.ReactNode }) {
  const complianceRequestContext = useComplianceRequestContext();
  const configContext = useConfigContext();
  const consentStateContext = useConsentStateContext();
  const consentTypesContext = useConsentTypesContext();
  const privacySettingsContext = usePrivacySettingsContext(
    configContext,
    consentStateContext,
    consentTypesContext,
  );
  const widgetStateContext = useWidgetStateContext(
    configContext,
    privacySettingsContext,
  );

  return (
    <ConfigContext.Provider value={configContext}>
      <ComplianceRequestContext.Provider value={complianceRequestContext}>
        <ConsentStateContext.Provider value={consentStateContext}>
          <ConsentTypesContext.Provider value={consentTypesContext}>
            <PrivacySettingsContext.Provider value={privacySettingsContext}>
              <WidgetStateContext.Provider value={widgetStateContext}>
                {children}
              </WidgetStateContext.Provider>
            </PrivacySettingsContext.Provider>
          </ConsentTypesContext.Provider>
        </ConsentStateContext.Provider>
      </ComplianceRequestContext.Provider>
    </ConfigContext.Provider>
  );
}
